module.exports = __webpack_public_path__ + "static/media/local-icon.88321539.svg";